import moment from 'moment'
import { SUPPORTED_LOCALES } from '@/helpers/constants'
import { storage } from '@/helpers/utils'
import { createI18n } from 'vue-i18n'

const DEFAULT_LOCALE = 'en'

export const resolveLocale = (locale) => {
	if (!locale) return DEFAULT_LOCALE
	// region locales (e.g. "en-US") are not supported
	locale = locale.split('-')[0]

	// check that root locale is supported
	if (!SUPPORTED_LOCALES[locale]) {
		console.error(`Localization: locale "${locale}" is not supported`)
		return DEFAULT_LOCALE
	}

	return locale
}

export const PREFERRED_LOCALE = resolveLocale(
	storage.get('pronto_dev_locale') || window.navigator.language
)

const i18n = createI18n({
	allowComposition: true,
	locale: DEFAULT_LOCALE, // set locale
	fallbackLocale: DEFAULT_LOCALE, // set fallback locale
	messages: {},
})

i18n.DEFAULT_LOCALE = DEFAULT_LOCALE
i18n.loaded = false

export default i18n

export const changeLocale = (locale) => {
	locale = resolveLocale(locale)

	i18n.global.locale = locale
	moment.locale(locale)
}

export const formatNumber = (value, options) => {
	const formatter = new Intl.NumberFormat(i18n.global.locale, options)
	return formatter.format(value)
}

export const loadLocaleAsync = async (locale) => {
	console.debug('i18n', `loading async locale file for "${locale}"...`)
	if (!locale || window.Cypress) {
		// if running in test env, just async load "en" locale in test
		return changeLocale(DEFAULT_LOCALE)
	}

	locale = resolveLocale(locale)

	if (i18n.global.messages[locale]) {
		// this locale has already been loaded, so just set it
		EventBus.$emit('i18n-loaded')
		return changeLocale(locale)
	}

	try {
		console.debug('i18n', `fetching locale file for "${locale}"...`)
		const messagesMod = await import(`../i18n/locale/${locale}.json?raw`)
		const messages = JSON.parse(messagesMod.default)

		// update state with all of the info we need
		i18n.global.setLocaleMessage(locale, messages)
		changeLocale(locale)
		i18n.loaded = true
		console.debug('i18n', 'locale file loaded and messages set')
		EventBus.$emit('i18n-loaded')
	} catch (e) {
		console.error(e)
	}
}
